<template>
  <div class="cl-inner">
    <div class="list-oper"></div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="roleList"
      :rowKey="(record) => record.id"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
    >
      <span slot="id"></span>
      <span slot="institutionName"></span>
      <span slot="address" slot-scope="text, record">
        <template>
          <span>{{ record.provinceId | codeFilter }}</span>
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.roleForm.init('update', record)">修改</a>
        </template>
      </span>
    </a-table>
    <role-form-modal ref="roleForm" @addRole="addRole"></role-form-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import role from '../../api/role'

import RoleFormModal from './RoleFormModal'

import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '角色名称',
    dataIndex: 'roleName',
    key: 'roleName',
  },
  {
    title: '角色描述',
    dataIndex: 'roleDesc',
    key: 'roleDesc',
  },
  {
    title: '人员数量',
    dataIndex: 'userCount',
    key: 'userCount',
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'roleList',
  data() {
    return {
      roleList: [], //角色的数据
      columns, //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
      queryParams: {}, //用于改变数据时的查询参数
    }
  },
  components: {
    CTable,
    RoleFormModal,
  },
  methods: {
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.queryParams = obj
      this.getAccRoleList(obj)
    },

    //新增修改一个角色,带条件查询列表
    addRole(role) {
      //查询表格的权限数据
      this.getAccRoleList(this.queryParams)
    },

    //角色列表
    getAccRoleList(params) {
      this.loading = true
      role.getAccRoleList(params).then((res) => {
        // this.roleList = res.data.list
        // console.log('this.roleList', this.roleList)
        this.roleList = res.data.list.filter((item) => {
          if (item.roleName != '代理负责人') {
            return item
          }
        })
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
  },

  created() {
    //查询角色列表
    this.getAccRoleList()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.role-list-title {
  font-size: 25px;
  font-weight: bold;
  height: 39px;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
}
</style>
